import Vue from "vue";

export const ClickOutsideElement = {
  bind(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      const component = vNode.context.name;
      let warn = `[Vue-click-outside-element:] provided expression '${binding.expression}' is not a function, but has to be`;

      if (component) {
        warn += `Found in component '${component}'`;
      }

      console.error(warn);
    }
    // Define Handler and cache it on the element.
    const bubble = binding.modifiers.bubble;
    const handler = e => {
      // Vuetify overlays (menus, dialogs, pickers, tooltips) render detached
      // from the triggering element's DOM subtree, so a click inside one of
      // those would otherwise look identical to a click "outside" el. This
      // includes tooltip bubbles (e.g. the Download/Archive/Delete button
      // tooltips in the Documents tab file list), which can render on top of
      // nearby controls like the "Archived" checkbox.
      const isOverlayClick =
        typeof e.target.closest === "function" &&
        e.target.closest(
          ".v-menu__content, .v-dialog, .v-overlay, .v-picker, .v-select-list, .v-tooltip__content"
        );

      if (isOverlayClick) return;

      // A click target that isn't attached to the document at all (as
      // opposed to merely being outside `el`) is a stray/ghost event: Vue
      // just tore down that element's DOM (e.g. a data refetch swapped in a
      // whole new set of list rows) and something dispatched a click on the
      // node on its way out. That's never a genuine "click outside" from the
      // user - only a live, still-attached element elsewhere on the page
      // counts as one.
      const isDetachedTarget = !document.body.contains(e.target);

      if (isDetachedTarget) return;

      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };

    el.__vueClickOutsideElement__ = handler;

    // Add Event Listeners.
    document.addEventListener("click", handler);
  },
  unbind(el) {
    // Remove Event Listeners.
    document.removeEventListener("click", el.__vueClickOutsideElement__);

    el.__vueClickOutsideElement__ = null;
  }
};

Vue.directive("click-outside-element", ClickOutsideElement);
